export interface LinkSummary {
  first?: string | undefined;
  restCount: number;
  isEmpty: boolean;
}

// Compress a link array into "first link + N more" for compact table cells.
export function summarizeLinks(links?: string[]): LinkSummary {
  if (!links || links.length === 0) {
    return { first: undefined, restCount: 0, isEmpty: true };
  }
  return { first: links[0], restCount: links.length - 1, isEmpty: false };
}
